import { createFileRoute } from '@tanstack/react-router';

import { FeatureFlagsPage } from '@/areas/settings/OrganizationSettings/pages/FeatureFlagsPage/FeatureFlagsPage';
import { canViewFeatureFlagsSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/feature-flags')({
    staticData: { access: { permissions: canViewFeatureFlagsSettings }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <FeatureFlagsPage />;
}
